<div class="request-password-reset">
  <app-logo></app-logo>
  <h2 class="request-password-reset__title title-xl">
    {{ 'ENTER_EMAIL_L' | translate }}
  </h2>

  <div class="request-password-reset-form__content">
    <hr class="mb30" />

    <h4 class="request-password-reset__form-title title-m">
      {{ 'FORGOT_PASSWORD_TITLE_L' | translate }}
    </h4>
    <p class="request-password-reset__form-subtitle default-s">
      {{ 'FORGOT_PASSWORD_SUBTITLE_L' | translate }}
    </p>
    <div class="row">
      <div class="col-12 mb20">
        <app-form-field>
          <app-form-field-label
            >{{ 'general.email_address_l' | translate }}
          </app-form-field-label>
          <input
            appInput
            type="email"
            required
            appAutofocus
            placeholder="{{ 'forms.type_email_address_l' | translate }}"
            [formControl]="emailControl"
            class="form-control"
          />
        </app-form-field>
      </div>
      <div class="col-12 mb20">
        <hr class="mb15" />
        <div class="d-flex justify-content-between px-1">
          <app-button [type]="'light-bordered'" (clickEvent)="cancel()">
            {{ 'general.cancel_a' | translate }}
          </app-button>

          <app-button
            id="save-btn"
            [disabled]="emailControl.invalid || (actionState$ | async)?.pending"
            [type]="'light-bordered'"
            [loading]="(actionState$ | async)?.pending"
            (clickEvent)="submit()"
          >
            {{ 'RESET_PASSWORD_L' | translate }}
          </app-button>
        </div>
      </div>
    </div>
  </div>
  @if (errorMessage$ | async) {
    <div class="col-12 mb20">
      <app-message [messageType]="'error'"
        ><span>{{ errorMessage$ | async | translate }}</span></app-message
      >
    </div>
  }
  @if ((actionState$ | async)?.done) {
    <app-message [messageType]="'info'">
      <div>{{ 'PASSWORD_RESET_EMAIL_SENT_L' | translate }}</div>
    </app-message>
  }
</div>
